<template>
    <div>
        <b-form-checkbox
            v-model="value"
            class="checkbox"
        >
            Include non-billable costs
        </b-form-checkbox>

        <b-form-checkbox
            v-model="hideZeroQuantity"
            class="checkbox"
        >
            Hide costs with zero quantity
        </b-form-checkbox>

        <b-form-checkbox
            v-model="showResources"
            class="checkbox"
        >
            Show resources
        </b-form-checkbox>

        <div class="mt-2">
            <h5>
                Cost types
            </h5>
            <CostTypeSelect
                v-model="costTypes"
                :multiple="true"
            />
        </div>
    </div>
</template>
<script>
import { sync } from 'vuex-pathify';
import CostTypeSelect from '@/components/CostTypeSelect.vue';

export default {
    components: { CostTypeSelect },
    computed: {
        value: sync('document/field@options.include_non_billable_costs'),
        costTypes: sync('document/field@options.cost_types'),
        showResources: sync('document/field@options.show_resources'),
        hideZeroQuantity: sync('document/field@options.hide_zero_quantity'),
    },
};
</script>
